import React from 'react';
import { PhoneIncomingIcon, MoonStarIcon, TargetIcon } from 'lucide-react';
import { Card, CardHeader, CardBody } from '../Card';
import { Badge } from '../Badge';
type Benefit = {
  icon: React.ReactNode;
  title: string;
  body: string;
};
const BENEFITS: Benefit[] = [{
  icon: <PhoneIncomingIcon className="h-6 w-6" aria-hidden="true" data-id="element-122" />,
  title: '電話対応から解放される',
  body: '鳴り続ける電話に手を止められることがなくなります。受付の負担が減り、スタッフは目の前の仕事に専念できます。'
}, {
  icon: <MoonStarIcon className="h-6 w-6" aria-hidden="true" data-id="element-123" />,
  title: '営業時間外の取りこぼしゼロ',
  body: '夜間も定休日も、予約や問い合わせをしっかり受け止めます。「出られなかった一件」をなくし、機会損失を防ぎます。'
}, {
  icon: <TargetIcon className="h-6 w-6" aria-hidden="true" data-id="element-124" />,
  title: '本業に集中できる',
  body: '雑務に追われる時間が減り、本来力を入れたい仕事やお客さまとの時間に集中できます。会社が前に進みはじめます。'
}];
export function BenefitsSection() {
  return <section id="benefits" className="w-full scroll-mt-24 bg-surface-muted" data-id="element-125">
      <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6 sm:py-24" data-id="element-126">
        <div className="mx-auto max-w-2xl text-center" data-id="element-127">
          <Badge variant="sky" data-id="element-128">導入で変わること</Badge>
          <h2 className="mt-4 text-2xl font-bold text-text sm:text-3xl" data-id="element-129">
            「対応」から解放されて、本業に集中できる毎日へ
          </h2>
          <p className="mt-4 text-base leading-relaxed text-text-muted" data-id="element-130">
            AI受付スタッフがもたらすのは、むずかしい仕組みではなく、日々の働き方の変化です。
          </p>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-3" data-id="element-131">
          {BENEFITS.map(b => <Card key={b.title} variant="elevated" className="h-full" data-id="element-132">
              <CardHeader data-id="element-133">
                <span className="inline-flex h-12 w-12 items-center justify-center rounded-md bg-deep-navy text-white" data-id="element-134">
                  {b.icon}
                </span>
                <h3 className="mt-4 text-lg font-bold text-text" data-id="element-135">{b.title}</h3>
              </CardHeader>
              <CardBody data-id="element-136">{b.body}</CardBody>
            </Card>)}
        </div>
      </div>
    </section>;
}